// Import the functions you need from the SDKs you need
import { initializeApp, FirebaseApp } from "firebase/app";
import { getAnalytics, Analytics, isSupported } from "firebase/analytics";
import { getPerformance } from "firebase/performance";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDxerf_q63PnkvL0iUMoLow3IgL3252hm0",
  authDomain: "ukulele-seekho.firebaseapp.com",
  projectId: "ukulele-seekho",
  storageBucket: "ukulele-seekho.firebasestorage.app",
  messagingSenderId: "690959764624",
  appId: "1:690959764624:web:221d0631d1a3c765705c15",
  measurementId: "G-HYKTTPECCW"
};

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics: Analytics | null = null;
if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

// Initialize Performance Monitoring (only in browser environment)
let performance: ReturnType<typeof getPerformance> | null = null;
if (typeof window !== "undefined") {
  try {
    performance = getPerformance(app);
  } catch (error) {
    console.warn("Firebase Performance Monitoring not available:", error);
  }
}

// Error logging function (since Crashlytics is not available for web)
// You can integrate with services like Sentry, LogRocket, or use Firebase Remote Config
export const logError = (error: Error, context?: Record<string, any>) => {
  console.error("Application Error:", error, context);
  
  // You can send errors to your backend API here
  // Example:
  // fetch('/api/log-error', {
  //   method: 'POST',
  //   body: JSON.stringify({ error: error.message, stack: error.stack, context })
  // });
  
  // Or use a service like Sentry:
  // Sentry.captureException(error, { extra: context });
};

// Export for use in other files
export { app, analytics, performance };
export default app;